export default __webpack_public_path__ + "static/media/question-blue.fc360484.png";